import * as StackTrace from 'stacktrace-js';

// Required global for stackdriver-errors-js
(window as any).StackTrace = StackTrace;

import { StackdriverErrorReporter } from 'stackdriver-errors-js';

const environment = process.env.NODE_ENV;

let errorHandler: StackdriverErrorReporter = null;

if (environment === 'production') {
  errorHandler = new StackdriverErrorReporter();
  errorHandler.start({
    key: 'AIzaSyDOpGB7m0sSXR1TbxTHIkb5ynA_6-vQXzU',
    projectId: 's-plat',
    service: 'FastFlow'
  });
}

export default class ErrorReportingService {
  public static report(err: Error, callback?: () => void): void {
    if (environment === 'production') {
      return errorHandler.report(err, callback);
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/ErrorReportingService.ts